<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" lang="en" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
  <head>
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <title>Welcome to Hebern - Email Confirmation</title>
    <style type="text/css">
      /* Email-safe styles - all inline in head */
      body {
        margin: 0 !important;
        padding: 0 !important;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
        background-color: #ffffff !important;
        color: #000000;
        width: 100% !important;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }
      img {
        border: 0;
        max-width: 100%;
        height: auto;
        display: block;
      }
      table {
        border-collapse: collapse;
        mso-table-lspace: 0pt;
        mso-table-rspace: 0pt;
      }
      table td {
        border-collapse: collapse;
      }
      .loading-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 100vh;
        background-color: #ffffff;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
      }
      .loading-spinner {
        width: 40px;
        height: 40px;
        border: 4px solid #f3f3f3;
        border-top: 4px solid #000000;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        margin-bottom: 20px;
      }
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
      .loading-container p {
        color: #000000;
        font-size: 16px;
        margin: 0;
      }
      .email-body {
        margin: 0 !important;
        padding: 0 !important;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
        background-color: #ffffff !important;
        width: 100% !important;
      }
      .email-wrapper {
        background-color: #ffffff;
        width: 100%;
      }
      .email-center {
        padding: 20px 0;
      }
      .email-container {
        max-width: 600px;
        background-color: #ffffff;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      }
      .email-header {
        padding: 40px 40px 20px 40px;
        text-align: center;
        background-color: #000000; /* Fallback for email clients that don't support gradients */
        background: linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #000000 100%);
        border-radius: 8px 8px 0 0;
        position: relative;
        overflow: hidden;
      }
      .email-logo-container {
        margin-bottom: 20px;
      }
      .email-logo {
        max-width: 120px;
        height: auto;
        display: block;
        margin: 0 auto;
      }
      .email-title {
        margin: 0;
        font-size: 28px;
        font-weight: 700;
        letter-spacing: 1px;
        background: linear-gradient(135deg, #efbf04, #f4ec9a);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
        color: #efbf04;
      }
      .email-content {
        padding: 40px;
      }
      .email-subtitle {
        margin: 0 0 20px 0;
        color: #000000;
        font-size: 24px;
        font-weight: 600;
      }
      .email-text {
        margin: 0 0 20px 0;
        color: #000000;
        font-size: 16px;
        line-height: 1.6;
      }
      .email-list {
        margin: 0 0 20px 0;
        padding-left: 20px;
        color: #000000;
        font-size: 16px;
        line-height: 1.6;
      }
      .email-list-item {
        margin-bottom: 8px;
      }
      .email-button-container {
        margin: 30px 0;
      }
      .email-cta-button {
        display: inline-block;
        padding: 15px 30px;
        background: linear-gradient(135deg, #000000 0%, #323232 100%);
        color: #efbf04 !important;
        text-decoration: none;
        border-radius: 6px;
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 0.5px;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.12);
      }
      .btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: none;
        cursor: pointer;
        font-family: inherit;
        font-weight: 500;
        text-decoration: none;
        padding: 12px 24px;
        font-size: 16px;
        border-radius: 6px;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.12);
      }
      .btn-primary {
        background: linear-gradient(135deg, #000000, #323232);
        color: #efbf04 !important;
      }
      .email-footer {
        padding: 30px 40px;
        background-color: #000000; /* Fallback for email clients that don't support gradients */
        background: linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #000000 100%);
        border-radius: 0 0 8px 8px;
        text-align: center;
        position: relative;
        overflow: hidden;
      }
      .email-footer-title {
        margin: 0 0 10px 0;
        color: #efbf04;
        font-size: 14px;
      }
      .email-footer-tagline {
        margin: 0 0 15px 0;
        color: #999999;
        font-size: 12px;
        line-height: 1.4;
      }
      .email-footer-disclaimer {
        margin: 0;
        color: #999999;
        font-size: 11px;
      }
      .email-unsubscribe-link {
        color: #efbf04 !important;
        text-decoration: underline !important;
      }
      @media only screen and (max-width: 600px) {
        .email-container {
          width: 100% !important;
          max-width: 100% !important;
        }
        .email-content {
          padding: 20px !important;
        }
        .email-header {
          padding: 30px 20px 15px 20px !important;
        }
        .email-logo {
          max-width: 100px !important;
        }
        .email-footer {
          padding: 20px !important;
        }
        .email-title {
          font-size: 24px !important;
        }
        .email-subtitle {
          font-size: 20px !important;
        }
        .email-cta-button {
          display: block !important;
          width: 100% !important;
          text-align: center !important;
          padding: 12px 20px !important;
        }
      }
    </style>
  </head>
  <body class="email-body">
    <!-- Loading state -->
    @if (!isLoaded) {
    <div class="loading-container">
      <div class="loading-spinner"></div>
      <p>Loading confirmation email...</p>
    </div>
    }

    <!-- Main email content - only show when loaded -->
    @if (isLoaded) {
    <div>
      <table
        role="presentation"
        cellspacing="0"
        cellpadding="0"
        border="0"
        width="100%"
        class="email-wrapper"
      >
        <tr>
          <td align="center" class="email-center">
            <table
              role="presentation"
              cellspacing="0"
              cellpadding="0"
              border="0"
              width="600" style="max-width: 600px;"
              class="email-container"
            >
              <!-- Header -->
              <tr>
                <td class="email-header" style="background-color: #000000; background: linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #000000 100%); text-align: center;">
                  <div class="email-logo-container" style="margin-bottom: 20px;">
                    <img
                      src="{{ logoUrl }}"
                      alt="Hebern Logo"
                      class="email-logo"
                      width="120" style="max-width: 120px; height: auto; display: block; margin: 0 auto;"
                    />
                  </div>
                  <h1 class="email-title" style="margin: 0; font-size: 28px; font-weight: 700; letter-spacing: 1px; color: #efbf04; text-align: center;">Welcome to Hebern</h1>
                </td>
              </tr>

              <!-- Main Content -->
              <tr>
                <td class="email-content" style="padding: 40px;">
                  <h2 class="email-subtitle">Thank You for Joining Us!</h2>

                  <p class="email-text">
                    Hello{{ userName ? " " + userName : "" }},
                  </p>

                  <p class="email-text">
                    We're thrilled to welcome you to the Hebern community! Your
                    email address <strong>{{ userEmail }}</strong> has been
                    successfully added to our mailing list.
                  </p>

                  <p class="email-text">
                    You can expect to receive updates about:
                  </p>

                  <ul class="email-list">
                    <li class="email-list-item">
                      New security features and enhancements
                    </li>
                    <li class="email-list-item">
                      Platform updates and maintenance notifications
                    </li>
                    <li class="email-list-item">
                      Exclusive tips and insights from our security team
                    </li>
                    <li class="email-list-item">
                      Updates about our upcoming beta test
                    </li>
                  </ul>

                  <p class="email-text">
                    We'd love to learn more about you! Your feedback helps us
                    better serve your needs. If you are interested in becoming a
                    beta tester, filling out our survey will serve as your
                    application.
                  </p>

                  <!-- CTA Button -->
                  <table
                    role="presentation"
                    cellspacing="0"
                    cellpadding="0"
                    border="0"
                    class="email-button-container"
                  >
                    <tr>
                      <td align="center">
                        <!--[if mso]>
                        <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" href="{{ surveyUrl }}" style="height:48px; v-text-anchor:middle; width:260px;" arcsize="8%" strokecolor="#000000" fillcolor="#000000">
                          <w:anchorlock/>
                          <center style="color:#efbf04; font-family:Segoe UI, Arial, sans-serif; font-size:16px; font-weight:500;">Take our Survey</center>
                        </v:roundrect>
                        <![endif]-->
                        <!--[if !mso]><!-- -->
                        <a href="{{ surveyUrl }}" class="btn btn-primary email-cta-button" style="display: inline-block; padding: 15px 30px; background: linear-gradient(135deg, #000000 0%, #323232 100%); color: #efbf04 !important; text-decoration: none; border-radius: 6px; font-size: 16px; font-weight: 500; letter-spacing: 0.5px; box-shadow: 0 3px 6px rgba(0, 0, 0, 0.12);">Take our Survey</a>
                        <!--<![endif]-->
                      </td>
                    </tr>
                  </table>

                  <p class="email-text">
                    If you have any questions or need assistance, please don't
                    hesitate to reach out to our support team.
                  </p>
                </td>
              </tr>

              <!-- Footer -->
              <tr>
                <td class="email-footer" style="background-color: #000000; background: linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #000000 100%); text-align: center;">
                  <p class="email-footer-title" style="margin: 0 0 10px 0; color: #efbf04; font-size: 14px;">
                    <strong>Hebern</strong>
                  </p>
                  <p class="email-footer-tagline" style="margin: 0 0 15px 0; color: #999999; font-size: 12px; line-height: 1.4;">
                    Secure • Encrypted • Reliable<br />
                    Your privacy and security are our top priorities
                  </p>
                  <p class="email-footer-disclaimer" style="margin: 0; color: #999999; font-size: 11px;">
                    This email was sent to {{ userEmail }} because you signed up
                    for our mailing list.<br />
                    If you no longer wish to receive these emails, you can
                    <a
                      href="{{ unsubscribeUrl }}"
                      class="email-unsubscribe-link"
                      style="color: #efbf04 !important; text-decoration: underline !important;"
                      >unsubscribe here</a
                    >.
                  </p>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
    <!-- End of main email content -->
    }
  </body>
</html>
